import ReactOnRails from 'react-on-rails';
import { Toaster } from 'react-hot-toast';
import Breadcrumb from './shared/Breadcrumb';
import Calendar from './calendar/Calendar';
import CalendarCategoryList from './calendarCategories/calendar/CalendarCategoryList';
import CalendarCategoriesSettings from './calendarCategories/settings/CalendarCategoriesSettings';
import Directory from './directory/Directory';
import FavoritePage from './directory/FavouritePage';
import Groups from './directory/Groups';
import GenerateAISceneDropdownItem from './documents/GenerateAISceneDropdownItem';
import FolderDocumentShareDropdownItem from './projects/FolderDocumentShareDropdownItem';
import FolderDocumentShareLanding from './projects/FolderDocumentShareLanding';
import Footer from './shared/Footer';
import SceneCardAIBetaAlert from './sceneCards/SceneCardAIBetaAlert';
import SceneActionsOverview from './sceneCards/SceneActionsOverview';
import SceneCardCalendarEvent from './sceneCards/SceneCardCalendarEvent';
import SceneCardEventsList from './sceneCards/SceneCardEventsList';
import SceneCardsPermissionsDialog from './shared/SceneCardsPermissionsDialog';
import LottieMagicStick from './sceneCards/LottieMagicStick';
import MagicStick from '../assets/icons/MagicStick';
import NeedsReview from './sceneCards/NeedsReview';
import TeamPositionTooltip from './team/TeamPositionTooltip';
import GuideTooltip from './shared/GuideTooltip';
import InactiveSubscriptionAlert from './shared/InactiveSubscriptionAlert';
import TwoFactorAuthFlowComponent from './auth/TwoFactorAuth/TwoFactorAuthFlow';
import SubmissionBoardsPage from './submission_boards/SubmissionBoardsPage';
import SbMediaRequestPage from './submission_boards/SbMediaRequestPage';
import SbProfileSelector from './submission_boards/SbProfileSelector';
import SbRecipientPage from './submission_boards/recipient/SbRecipientPage';
import SubmissionKitsPage from './submission_kits/SubmissionKitsPage';
import MediaKitsPage from './media_kits/MediaKitsPage';
import SubmissionKitsViewPage from './submission_kits/SubmissionKitsViewPage';
import UserPlansPage from './user_plans/UserPlansPage';
import StripConfirmPage from './user_plans/StripConfirmPage';
import HmuKitPhotos from './hair_make_up_kits/HmuKitPhotos';
import WardrobeKitPhotos from './wardrobe_kits/WardrobeKitPhotos';
import { ProfileDetailView } from './profiles/ProfileViews';
import ProfileCard from './profile/ProfileCard';
import OverviewContent from './profile/edit/OverviewContent';
import ProfilePage from './profile/ProfilePage';
import PhoneInput from './shared/PhoneInput';
import EthnicityInput from './shared/EthnicityInput';
import ProTrialIcon from './profile/edit/ProTrialIcon';
import EditableFileName from './profile/EditableFileName';
import ImageCropInput from './shared/ImageCropInput';
import HeadshotEditor from './profile/edit/HeadshotEditor';
import PublicProfileSettings from './profile/edit/PublicProfileSettings';
import SupportHowToPage from './support/SupportHowToPage';

ReactOnRails.setOptions({ turbo: true } as any);
ReactOnRails.register({
  Breadcrumb,
  CalendarCategoryList,
  Calendar,
  CalendarCategoriesSettings,
  Directory,
  Footer,
  GenerateAISceneDropdownItem,
  FolderDocumentShareDropdownItem,
  FolderDocumentShareLanding,
  GdPrevizShareDropdownItem: FolderDocumentShareDropdownItem,
  GdPrevizSharedLanding: FolderDocumentShareLanding,
  LottieMagicStick,
  MagicStick,
  NeedsReview,
  SceneCardAIBetaAlert,
  SceneActionsOverview,
  SceneCardEventsList,
  SceneCardCalendarEvent,
  SceneCardsPermissionsDialog,
  Toaster,
  TeamPositionTooltip,
  GuideTooltip,
  TwoFactorAuthFlow: TwoFactorAuthFlowComponent,
  InactiveSubscriptionAlert,
  SubmissionBoardsPage, // submission board list
  SbMediaRequestPage, // For a submissionboard, asked performer to submit media
  SbProfileSelector, // from member directory
  SbRecipientPage, // email link, recipient submission board
  SubmissionKitsPage, // submission kit list
  MediaKitsPage, // media kit list
  SubmissionKitsViewPage, // show submission kit for a user
  UserPlansPage, // manage subscription
  StripConfirmPage, // stripe payment confirmation
  FavoritePage,
  Groups,
  HmuKitPhotos, // Hair & Make-up Kit Photos
  WardrobeKitPhotos, // Wardrobe Kit Photos
  ProfileDetailView, // Profile Detail View Modal
  // ProfilePopupManager, // Global Profile Popup Manager
  ProfileCard, // Profile Card View
  OverviewContent, // Overview Tab Content
  ProfilePage,
  PhoneInput, // Phone Input with Country Dropdown
  EthnicityInput, // Ethnicity Input with Tags
  ProTrialIcon, // Ethnicity Input with Tags
  EditableFileName, // Editable File Name with Double-Click
  ImageCropInput, // Image Crop Input with Modal
  HeadshotEditor, // Headshot Editor with Crop
  PublicProfileSettings, // Public Profile Settings with real-time validation
  SupportHowToPage,
});
